import { Badge, SidebarMenuButton } from "@altimateai/lego";
import { IconMessageCircle } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { useIntercom } from "react-use-intercom";
import { useSidebar } from "@altimateai/lego";

interface ChatWithUsProps {
  text?: string;
  className?: string;
}

const ChatWithUs = ({ text = "Chat with Us", className }: ChatWithUsProps) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { show } = useIntercom();
  const { state } = useSidebar();

  useEffect(() => {
    const handleUnreadCountChange = (count: number) => {
      setUnreadCount(count);
    };

    if (window.Intercom) {
      window.Intercom("onUnreadCountChange", handleUnreadCountChange);
    }

    return () => {
      if (window.Intercom) {
        window.Intercom("onUnreadCountChange", () => {});
      }
    };
  }, []);

  return (
    <SidebarMenuButton
      onClick={() => show()}
      tooltip="Chat with Us"
      className={cn(
        "[&>svg]:al-size-5 al-text-muted-foreground",
        state === "expanded" ? "al-p-3" : "",
        className
      )}
    >
      <IconMessageCircle />
      <span className={cn("al-flex-1", "group-data-[state=collapsed]:al-hidden")}>{text}</span>
      {unreadCount > 0 && (
        <Badge
          className="al-h-5 al-min-w-5 al-text-red-500 group-data-[state=collapsed]:al-hidden"
          variant="outline"
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </Badge>
      )}
    </SidebarMenuButton>
  );
};

export { ChatWithUs };
